var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.ready)?_c('router-view',{on:{"routeEvents":_vm.testa}}):_vm._e(),_c('LoaderComponent',{attrs:{"value":!_vm.ready}}),(_vm.displayConfirm)?_c('ConfirmComponent'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }